import httpClient from "@/shared/lib/httpClient";
import { MappingResponse, TabulationResponse, UserValidationRequest } from "../types";

export async function uploadForMapping(file: File): Promise<MappingResponse> {
    const form = new FormData();
    form.append("file", file);

    return httpClient.uploadFile<MappingResponse>("/mapping", form, {
        requiresAuth: true,
    });
}

export async function sendValidation(request: UserValidationRequest): Promise<TabulationResponse> {
    return httpClient.post<TabulationResponse>("/tabulation", request, {
        requiresAuth: true,
    });
}

// Legacy default export for backwards compatibility
const DreService = {
    uploadForMapping,
    sendValidation
};

export default DreService;
